import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUsers, createUser } from '../../services/user';

export const getUsers = createAsyncThunk(
    'users/getUsers',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await fetchUsers(data, token.token);
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch users');
      }
    }
  );